import { render, staticRenderFns } from "./search-on-social-media-and-mobile-chat.vue?vue&type=template&id=3132ff98"
import script from "./search-on-social-media-and-mobile-chat.vue?vue&type=script&lang=js"
export * from "./search-on-social-media-and-mobile-chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/app/components/Navigation.vue').default,FooterMain: require('/app/components/FooterMain.vue').default})
